/* eslint-disable max-lines */
export const appointmentTypes = [
  {
    value: 'follow_up',
    label: 'Follow up'
  },
  {
    value: 'wellness_exam',
    label: 'Wellness exam'
  },
  {
    value: 'emergency',
    label: 'Emergency'
  },
  {
    value: 'nursing_only',
    label: 'Nursing only'
  },
  {
    value: 'new_patient',
    label: 'New patient'
  }
];

export const appointmentLengths = [
  {
    value: 10,
    label: '10 minutes'
  },
  {
    value: 15,
    label: '15 minutes'
  },
  {
    value: 20,
    label: '20 minutes'
  },
  {
    value: 25,
    label: '25 minutes'
  },
  {
    value: 30,
    label: '30 minutes'
  },
  {
    value: 35,
    label: '35 minutes'
  },
  {
    value: 40,
    label: '40 minutes'
  },
  {
    value: 45,
    label: '45 minutes'
  },
  {
    value: 50,
    label: '50 minutes'
  },
  {
    value: 55,
    label: '55 minutes'
  },
  {
    value: 60,
    label: '60 minutes'
  },
  {
    value: 75,
    label: '75 minutes'
  },
  {
    value: 90,
    label: '90 minutes'
  },
  {
    value: 120,
    label: '120 minutes'
  }
];

export const appointmentStatuses = [
  { value: 'unconfirmed', label: 'Unconfirmed', color: 'danger', property_of: 'check-in' },
  { value: 'confirmed', label: 'Confirmed', color: 'success', property_of: 'check-in' },
  { value: 'not_checked_in', label: 'Not Checked-in', color: 'danger', property_of: 'check-in' },
  {
    value: 'partially_checked_in',
    label: 'Partially Checked-in',
    color: 'warning',
    property_of: 'check-in'
  },
  { value: 'checked_in', label: 'Checked-in', color: 'success', property_of: 'check-in' },
  {
    value: 'balance_not_paid',
    label: 'Balance Not Paid',
    color: 'danger',
    property_of: 'financial'
  },
  {
    value: 'balance_partially_paid',
    label: 'Balance Partially Paid',
    color: 'warning',
    property_of: 'financial'
  },
  { value: 'balance_paid', label: 'Balance Paid', color: 'success', property_of: 'financial' },
  {
    value: 'no_cc_on_file',
    label: 'Pre-Auth not Signed',
    color: 'danger',
    property_of: 'financial'
  },
  { value: 'cc_on_file', label: 'Pre-Auth Signed', color: 'success', property_of: 'financial' },
  {
    value: 'cc_not_needed',
    label: 'Prior-Auth not Needed',
    color: 'neutral',
    property_of: 'financial'
  },
  { value: 'not_arrived', label: 'Not Arrived', color: 'danger', property_of: 'clinical' },
  { value: 'no_show', label: 'No Show', color: 'danger', property_of: 'clinical' },
  {
    value: 'arrived_waiting',
    label: 'Arrived Waiting',
    color: 'warning',
    property_of: 'clinical'
  },
  {
    value: 'appointment_ended',
    label: 'Appointment Ended',
    color: 'success',
    property_of: 'clinical'
  },
  {
    value: 'clinical_note_not_started',
    label: 'Clinical Note not Started',
    color: 'danger',
    property_of: 'clinical'
  },
  {
    value: 'clinical_note_started',
    label: 'Clinical Note Started',
    color: 'warning',
    property_of: 'clinical'
  },
  {
    value: 'clinical_note_locked',
    label: 'Clinical Note Locked',
    color: 'success',
    property_of: 'clinical'
  },
  {
    value: 'superbill_not_created',
    label: 'Superbill Not Created',
    color: 'danger',
    property_of: 'billing'
  },
  {
    value: 'superbill_not_scrubbed',
    label: 'Superbill Not Scrubbed',
    color: 'warning',
    property_of: 'billing'
  },
  {
    value: 'superbill_scrubbed',
    label: 'Superbill Scrubbed',
    color: 'success',
    property_of: 'billing'
  },
  {
    value: 'claim_not_created',
    label: 'Claim Not Created',
    color: 'danger',
    property_of: 'billing'
  },
  { value: 'claim_draft', label: 'Claim Draft', color: 'danger', property_of: 'billing' },
  { value: 'claim_ready', label: 'Claim Ready', color: 'warning', property_of: 'billing' },
  {
    value: 'claim_acknowledged',
    label: 'Claim Acknowledged',
    color: 'warning',
    property_of: 'billing'
  },
  { value: 'claim_rejected', label: 'Claim Rejected', color: 'danger', property_of: 'billing' },
  { value: 'claim_pending', label: 'Claim Pending', color: 'warning', property_of: 'billing' },
  { value: 'claim_denied', label: 'Claim Denied', color: 'danger', property_of: 'billing' },
  { value: 'claim_paid', label: 'Claim Paid', color: 'success', property_of: 'billing' },
  {
    value: 'claim_no_payment',
    label: 'Claim Processed (No Payment)',
    color: 'neutral',
    property_of: 'billing'
  },
  {
    value: 'completed',
    label: 'Completed',
    color: 'success',
    property_of: 'completed'
  },
  {
    value: 'cancelled', // don't touch this value!
    label: 'Canceled',
    color: 'danger',
    property_of: 'canceled'
  }
];

export const appointmentDataTypeState = [
  {
    value: 'with_appointments',
    label: 'Appointments',
    requiresModule: 'core.calendar_scheduling.appointments'
  },
  { value: 'with_events', label: 'Events', requiresModule: 'core.calendar_scheduling.events' },
  {
    value: 'with_time_block',
    label: 'Time Block',
    requiresModule: 'core.calendar_scheduling.time_blocks'
  }
];

export const appointmentConfirmedOptions = [
  {
    value: true,
    label: 'Confirmed'
  },
  {
    value: false,
    label: 'Unconfirmed'
  }
];

export const appointmentCheckinState = [
  { value: 'completed', label: 'Checked-In' },
  {
    value: 'pending',
    label: 'Partially Checked-In'
  },
  { value: 'incomplete', label: 'Not Checked-In' }
];

export const appointmentBalanceState = [
  { value: 'completed', label: 'Balance Paid' },
  {
    value: 'pending',
    label: 'Balance Partially Paid'
  },
  { value: 'incomplete', label: 'Balance Not Paid' }
];

export const appointmentCCState = [
  { value: 'completed', label: 'CC on File' },
  { value: 'incomplete', label: 'No CC on File' }
];

export const appointmentLocations = [
  { value: 'in_person', label: 'In-Person' },
  { value: 'virtual', label: 'Virtual' }
];
